/**
 * Who can open the gate/bar card scanner (v35 rules; moved out of Navbar for B-46,
 * when the Scan door moved from the navbar into the Wallet).
 * Clubs running membership cards only; club admins or people an admin flagged as
 * club staff (`canScan`). Sponsors never — they have their own Scan QR page.
 * The backend's `requireScanner` is the real gate; this only decides what to show.
 */
export const canScanCards = (membership) =>
  !!membership && membership.role !== 'sponsor' && !!membership.membershipCardsOn
  && (membership.role === 'admin' || !!membership.canScan || !!membership.clubAdmin);
